import { AxiosInstance } from 'axios';

import { APIManagerConfig } from '../apiManager';

const InventoryServiceFactory = ({ HTTPBase, config }: { HTTPBase: AxiosInstance; config: APIManagerConfig }) => ({
  getInventoryRequirements: (): Promise<any> => {
    return HTTPBase.get(`farm/${config.farmId}/reports/inventoryRequirements/data`).then((res) => res.data);
  },
});

export default InventoryServiceFactory;
